export const FIELDS = {
  KhoiLuongPhatSinh: 'KhoiLuongPhatSinh',
  KhoiLuongChuyenGiao: 'KhoiLuongChuyenGiao',
  KhoiLuongTuXuLy: 'KhoiLuongTuXuLy',
  KhoiLuongTonLuu: 'KhoiLuongTonLuu',
  PhuongPhapXuLy: 'PhuongPhapXuLy',
  DonViThuGom: 'DonViThuGom',
  NamBaoCao: 'NamThucHienBaoCao',
  NgayNopBaoCao: 'NgayNopBaoCao',
  HinhThucNop: 'HinhThucNop',
  LoaiFile: 'LoaiFile',
  attachmentType: 'attachmentType',
};



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/constants.js